const headerClass = "black--text font-weight-bold secondary";

export const degreeHeaders = [
  {
    text: "Short Name",
    value: "short_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Long Name",
    value: "long_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Level",
    value: "level",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Active Status",
    value: "active",
    class: "black--text font-weight-bold secondary capitalize",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const departmentHeaders = [
  {
    text: "Code",
    value: "code",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Active Status",
    value: "active",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const courseHeaders = [
  {
    text: "Code",
    value: "code",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Sub Type",
    value: "sub_type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Department",
    value: "department_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Active Status",
    value: "active",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    align: "end",
    sortable: false,
  },
];

export const courseDetailHeaders = [
  {
    text: "Objective",
    value: "objectives",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Outcome",
    value: "outcomes",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Experiment",
    value: "experiments",
    class: "black--text font-weight-bold secondary",
    align: "center",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    align: "end",
    sortable: false,
  },
  { text: "", value: "data-table-expand", width: "5%", sortable: false },
];

export const partnerHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Code",
    value: "code",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Type",
    value: "type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Whatsapp Number",
    value: "whatsapp_mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Application Approval Required",
    value: "partner_approval_required",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Collect Fee",
    value: "partner_payment_required",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Active Status",
    value: "active",
    class: "black--text font-weight-bold secondary capitalize",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const branchHeaders = [
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Sub Partner",
    value: "sub_partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Code",
    value: "code",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Whatsapp Number",
    value: "whatsapp_mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Active Status",
    value: "active",
    class: "black--text font-weight-bold secondary capitalize",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const ProgramApplicationScheduleHeaders = [
  {
    text: "Year",
    value: "year",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Start Date",
    value: "start_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "End Date",
    value: "end_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Course Start Date",
    value: "course_start_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const partnerAdmssionScheduleHeaders = [
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Application Start Date",
    value: "application_start_date_ind_format",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Application End Date",
    value: "application_end_date_ind_format",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Admission End Date",
    value: "admission_end_date_ind_format",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Course Start Date",
    value: "course_start_date_ind_format",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Pay-by Date",
    value: "pay_by_date_ind_format",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Active Status",
    value: "active_status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const partnerProgramHeaders = [
  {
    text: "Year",
    value: "year",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Start Date",
    value: "start_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "End Date",
    value: "end_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Admission End Date",
    value: "admission_end_date",
    class: "black--text font-weight-bold secondary",
    width: "9%",
  },
  {
    text: "Course Start Date",
    value: "course_start_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Tuition Advance Fee",
    value: "pre_app_fee",
    class: "black--text font-weight-bold secondary",
    width: "5%",
  },
  {
    text: "Loan Allowed",
    value: "loan_allowed",
    class: "black--text font-weight-bold secondary",
    width: "5%",
  },
  {
    text: "Installments Allowed",
    value: "no_of_installments",
    class: "black--text font-weight-bold secondary",
    width: "5%",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const subPartnerHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Code",
    value: "code",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Type",
    value: "type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Whatsapp Number",
    value: "whatsapp_mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner Approval Required",
    value: "partner_approval_required",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Collect Fee",
    value: "partner_payment_required",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Active Status",
    value: "active",
    class: "black--text font-weight-bold secondary capitalize",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const programHeaders = [
  {
    text: "Code",
    value: "code",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "degree_specialization",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Department",
    value: "department.name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Duration",
    value: "duration",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Active Status",
    value: "active",
    class: "black--text font-weight-bold secondary capitalize",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const batchHeaders = [
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "year_batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Current Term",
    value: "current_term",
    class: "black--text font-weight-bold secondary",
  },
  // {
  //   text: "Active Status",
  //   value: "active_status",
  //   class: "black--text font-weight-bold secondary",
  // },
  {
    text: "Schedule Terms",
    value: "set_term",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Status",
    value: "status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Is Last Term?",
    value: "is_last_term_closed",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const programBatchCourseFeeHeaders = [
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Tuition Fee Advance",
    value: "advance_fee",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Application Fee",
    value: "application_fee",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Admission Fee",
    value: "admission_fee",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Course Fee",
    value: "course_fee",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Annual Upfront",
    value: "annual_upfront",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Full Upfront",
    value: "full_upfront",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Exam Fee",
    value: "exam_fee",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Arrear Fee",
    value: "arrear_fee",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const courseUnitHeaders = [
  {
    text: "Unit Number",
    value: "unit_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Description",
    value: "description",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const courseVideoHeaders = [
  {
    text: "Week Number",
    value: "week_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "URL",
    value: "url",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Description",
    value: "description",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const syllabusSchemeHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Description",
    value: "description",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const programSchemeHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Description",
    value: "description",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Handled By",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Credits",
    value: "credits_label",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "status",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const programSchemeTermHeaders = [
  {
    text: "Term Number",
    value: "term_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Number of Core Courses",
    value: "no_of_courses",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Number of Electives",
    value: "no_of_electives",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "View Courses",
    value: "courses",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Credits",
    value: "total_credits",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Is Stream?",
    value: "is_stream",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const programSchemeTermCoursesHeaders = [
  {
    text: "",
    value: "order_controls",
    class: "black--text font-weight-bold secondary",
    width: "5%",
    sortable: false,
  },
  {
    text: "Order",
    value: "order_sequence",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Course Name",
    value: "course_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Course Code",
    value: "course_code",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Credits",
    value: "credits",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Type",
    value: "type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Handled By",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Assessment",
    value: "assessment_scheme_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const programSchemeTermElectivesHeaders = [
  {
    text: "",
    value: "order_controls",
    class: "black--text font-weight-bold secondary",
    width: "5%",
    sortable: false,
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Order",
    value: "order_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Courses",
    value: "courses",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Credits",
    value: "credits",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Assessment",
    value: "assessment_scheme_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const batchSchemeHeaders = [
  {
    text: "Programme",
    value: "program_batch_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Scheme",
    value: "program_scheme_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Download",
    value: "download",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const streamSchemeHeaders = [
  {
    text: "Year",
    value: "year",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Scheme",
    value: "program_scheme_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const assessmentSchemeHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Description",
    value: "description",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Internal Mark(Max)",
    value: "max_internal_marks",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "External Mark(Max)",
    value: "max_external_marks",
    class: "black--text font-weight-bold secondary",
  },
  // {
  //   text: "Pass Mark",
  //   value: "pass_mark",
  //   class: "black--text font-weight-bold secondary",
  // },
  // {
  //   text: "Internals",
  //   value: "no_of_internals",
  //   class: "black--text font-weight-bold secondary",
  // },
  // {
  //   text: "Scale to 100",
  //   value: "scale_to_hundred",
  //   class: "black--text font-weight-bold secondary",
  // },
  {
    text: "Scale to 100",
    value: "scale_to_hundred_label",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const streamHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Active Status",
    value: "active",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const timeSpentHeaders = [
  {
    text: "Unit",
    value: "unit",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Topic",
    value: "topic",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Time Spent(in Mts)",
    value: "time_spent_(mins)",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Content Type",
    value: "content_type",
    class: "black--text font-weight-bold secondary",
  },
];

export const coursecompletionHeaders = [
  {
    text: "Unit",
    value: "unit",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Topic",
    value: "topic",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Percentage Completion",
    value: "percentage_completion",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Content Type",
    value: "content_type",
    class: "black--text font-weight-bold secondary",
  },
];

export const assignmentMarkHeaders = [
  {
    text: "Unit",
    value: "unit",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Topic",
    value: "topic",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Assessment Score",
    value: "assessment_score",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Content Type",
    value: "content_type",
    class: "black--text font-weight-bold secondary",
  },
];

export const dashboardSummaryHeaders = [
  {
    text: "Course",
    value: "unit",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Content Type",
    value: "topic",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Percentage Completion",
    value: "percentage_completion",
    class: "black--text font-weight-bold secondary",
  },
];

export const reportHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Verifier",
    value: "verified_user_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Reviewer",
    value: "reviewed_user_id",
    class: "black--text font-weight-bold secondary",
  },
  // {
  //   text: "Approval Required",
  //   value: "partner_approval_required",
  //   class: "black--text font-weight-bold secondary",
  // },
  {
    text: "Partner Approval",
    value: "partner_approval_status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Approval Status",
    value: "application_status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "DEB Validated",
    value: "deb_validated",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Last Updated",
    value: "updated_at",
    class: "black--text font-weight-bold secondary",
    width: "15%",
  },
  // {

  //   text: "Amount To Be Paid",
  //   value: "amount_to_be_paid",
  //   class: "black--text font-weight-bold secondary",
  // },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Pending Reason",
    value: "pending_reason",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Rejected Reason",
    value: "rejection_reason",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const partnerReportHeaders = [
  {
    text: "Employee ID",
    value: "employee_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Last Updated",
    value: "updated_at",
    class: "black--text font-weight-bold secondary",
    width: "15%",
  },
  {
    text: "View",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const businessReportHeaders = [
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Payment Type",
    value: "option_selected",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Set Payment",
    value: "set_payment",
    class: "black--text font-weight-bold secondary",
    width: "15%",
  },
  {
    text: "Loan UTR",
    value: "loan_utr",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "View",
    value: "action_business",
    class: "black--text font-weight-bold secondary",
  },
];

export const misReportHeaders = [
  {
    text: "Pro",
    tooltip: "Programme",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Par",
    tooltip: "Partner",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "NPP",
    tooltip: "Non Paid Pre Applications",
    value: "non_paid_pre_applications",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Dra",
    tooltip: "Draft",
    value: "draft",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Sub",
    tooltip: "Submitted",
    value: "submitted",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Pen",
    tooltip: "Pending",
    value: "pending",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Rej",
    tooltip: "Rejected",
    value: "rejected",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "ReS",
    tooltip: "Re-Submitted",
    value: "re_submitted",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "PAD",
    tooltip: "Provisionally Approved",
    value: "provisional",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "App",
    tooltip: "Approved",
    value: "approved",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Adm",
    tooltip: "Admitted",
    value: "admitted",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Tot",
    tooltip: "Total",
    value: "total",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Adv. Tui Due (₹)",
    tooltip: "Advance Tuition Fee Due (₹)",
    value: "advance_fee_due",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Adv. Tui Paid (₹)",
    tooltip: "Advance Tuition Fee Paid (₹)",
    value: "advance_fee_paid",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Bal Due (₹)",
    tooltip: "Balance Fee Due (₹)",
    value: "balance_fee_due",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "FP",
    tooltip: "Fully Paid",
    value: "fully_paid",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "FPA",
    tooltip: "Fully Paid Amount (₹)",
    value: "fully_paid_amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "TF (₹)",
    tooltip: "Term Fee Paid (₹)",
    value: "term_fee_paid",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "AU (₹)",
    tooltip: "Annual Upfront Paid (₹)",
    value: "annual_upfront_paid",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "FU (₹)",
    tooltip: "Full Upfront Paid (₹)",
    value: "full_upfront_paid",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Tot. Paid (₹)",
    tooltip: "Total Fee Paid (₹)",
    value: "total_paid",
    class: "black--text font-weight-bold secondary",
  },
];

export const preApplicantHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "DOB",
    value: "dob",
    class: "black--text font-weight-bold secondary",
    width: "8%",
  },
  {
    text: "Mobile",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Last Updated At",
    value: "updated_at",
    class: "black--text font-weight-bold secondary",
  },
];

export const applicationHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile No",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "application_status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "User",
    value: "reviewed_user_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Last Updated",
    value: "updated_at",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const paidCfoHeaders = [
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (₹)",
    value: "payment_amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction ID",
    value: "transaction_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction Date",
    value: "payment_date",
    class: "black--text font-weight-bold secondary",
  },
];

export const preApplicantPendingHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Unique ID",
    value: "unique_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (₹)",
    value: "advance_fee_amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Last Updated",
    value: "updated_at",
    class: "black--text font-weight-bold secondary",
  },
];

export const onlyAdvancePaidHeaders = [
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Application Status",
    value: "application_status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (₹)",
    value: "advance_fee_amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Receipt Number",
    value: "receipt_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Payment Date & Time",
    value: "payment_date",
    class: "black--text font-weight-bold secondary",
  },
];

export const feeDuePendingHeaders = [
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Method",
    value: "option_selected",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Type",
    value: "plan_selected",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Application Status",
    value: "application_status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Advance Paid  (₹)",
    value: "advance_paid",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (₹)",
    value: "plan_amount_balance",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Last Updated",
    value: "updated_at",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "View Payments",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const fullyPaidHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Advance Amount (₹)",
    value: "advance_paid",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Method",
    value: "option_selected",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Type",
    value: "plan_selected",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (₹)",
    value: "plan_amount_paid",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "View",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const installmentsHeaders = [
  {
    text: "Date",
    value: "installment_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (₹)",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction Date",
    value: "transaction_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction Id",
    value: "transaction_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Paid",
    value: "status",
    class: "black--text font-weight-bold secondary",
  },
];

export const applicationStatusHeaders = [
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "DOB",
    value: "formmated_dob",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "application_status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Created At",
    value: "inserted_at",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Last Updated",
    value: "updated_at",
    class: "black--text font-weight-bold secondary",
  },
];

export const transactionHistoryHeaders = [
  {
    text: "Application ID",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Unique ID",
    value: "unique_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (₹)",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Type",
    value: "payment_detail",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mode",
    value: "payment_method_type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "auth_status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction ID",
    value: "transactionid",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction Date",
    value: "transaction_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "View",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const programBatchTermScheduleHeaders = [
  {
    text: "Term",
    value: "term",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Start Date",
    value: "start_date_ind_format",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "End Date",
    value: "end_date_ind_format",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const feeTypeHeaders = [
  {
    text: "Code",
    value: "code",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Service Categories",
    value: "categories",
    sortable: false,
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Self Partner",
    value: "is_self",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Business Partner",
    value: "is_business",
    class: "black--text font-weight-bold secondary",
  },
];

export const ugcAdmittedApplicantsHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Employee ID",
    value: "employee_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    width: "15%",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "DEB ID",
    value: "deb_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "ABC ID",
    value: "abc_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Gender",
    value: "gender",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "DOB",
    value: "dob",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    width: "9%",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_name",
    width: "8%",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Uploaded On",
    value: "ugc_uploaded_on",
    width: "6%",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Attempted At",
    value: "ugc_attempted_at",
    width: "8%",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Reason",
    value: "ugc_reason",
    width: "15%",
    class: "black--text font-weight-bold secondary",
  },
];

export const FeeRequestHeaders = [
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Student Count",
    value: "student_count",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Total Fee",
    value: "total_fee",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "View",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const FeeRequestYearBatchHeaders = [
  {
    text: "Year",
    value: "year",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Student Count",
    value: "student_count",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Total Fee",
    value: "total_fee",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "View",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const FeeRequestStudentHeaders = [
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Current Term",
    value: "current_term",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Fee",
    value: "fee",
    class: "black--text font-weight-bold secondary",
  },
];

export const revenueSplitHeaders = [
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Type",
    value: "partner_type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Fee Code",
    value: "fee_code",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: " Fee %",
    value: "fee_percentage",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "GST in %",
    value: "gst_percentage",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Actions",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const admissionHeaders = [
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile No",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "application_status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Pending Reason",
    value: "pending_reason",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Last Updated",
    value: "updated_at",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "View",
    value: "view",
    class: "black--text font-weight-bold secondary",
  },
];

export const settlementHeaders = [
  {
    text: "Date",
    value: "date",
    class: "black--text font-weight-bold secondary",
    width: "10%",
  },
  {
    text: "PV Number",
    value: "pv_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Net Credit(₹)",
    value: "net_credit",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Total Gross Amount(₹)",
    value: "total_gross_amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Total Charge Back Amount(₹)",
    value: "total_charge_back_amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Total Refund Amount(₹)",
    value: "total_refund_amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Escrow Tax Amount(₹)",
    value: "escrow_tx_amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Charges(₹)",
    value: "charges",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "GST(₹)",
    value: "gst",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Settled Amount(₹)",
    value: "settled_amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Settlements",
    value: "settled_transactions",
    class: "black--text font-weight-bold secondary",
  },
];

export const settlementTransactionHeaders = [
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Particular",
    value: "fee_type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Order ID",
    value: "ref1",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Reference Number",
    value: "pgi_ref_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction Date",
    value: "tx_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Gross(₹)",
    value: "gross_amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Charges(₹)",
    value: "charges",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "GST(₹)",
    value: "gst",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Net Amount(₹)",
    value: "net_amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mode",
    value: "pay_ref",
    class: "black--text font-weight-bold secondary",
  },
];

export const paymentsHeaders = [
  {
    text: "Date",
    value: "payment_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (₹)",
    value: "payment_amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction ID",
    value: "transaction_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Receipt Number",
    value: "receipt_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Finance Check",
    value: "finance_check",
    class: "black--text font-weight-bold secondary",
  },
];

export const markSetupHeaders = [
  {
    text: "Programme Batch",
    value: "program_batch.name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Term Number",
    value: "term_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner.name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Course",
    value: "course.name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Label",
    value: "description",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Date",
    value: "date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Marks",
    value: "view_student",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const markStudentHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mark",
    value: "mark",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];
export const RevenueSplitSummaryHeaders = [
  {
    text: "Fee Type",
    value: "fee_code",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (₹)",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "GST (in %)",
    value: "gst_percentage",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "GST Amount (₹)",
    value: "gst_amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Total Amount (₹)",
    value: "total_amount",
    class: "black--text font-weight-bold secondary",
  },
];

export const StudentElectiveProgramHeaders = [
  {
    text: "Programme Batch",
    value: "program_batch_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "View",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const StudentElectiveCourseHeaders = [
  {
    text: "Course",
    value: "course_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "View",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const StudentElectiveHeaders = [
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
];

export const studentInvoiceHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile No",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Term",
    value: "term_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Type",
    value: "type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Receipt Number",
    value: "receipt_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Reference Number",
    value: "transaction_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction Date",
    value: "transaction_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Papers",
    value: "papers",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const bulkPaymentHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount To Pay",
    value: "plan_amount_balance",
    class: "black--text font-weight-bold secondary",
  },
];

export const bulkPaymentReportHeaders = [
  {
    text: "Transaction ID",
    value: "transaction_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction Date",
    value: "transaction_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Number Of Students",
    value: "no_of_students",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },

  {
    text: "View Students",
    value: "view_students",
    class: "black--text font-weight-bold secondary",
  },
];

export const bulkPaymentStudentHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount Paid",
    value: "amount_paid",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Receipt Number",
    value: "receipt_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Finance Check",
    value: "finance_check",
    class: "black--text font-weight-bold secondary",
  },
];

export const profilePhotoVerificationHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "student_info.name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "student_info.email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "student_info.mobile_no",
    class: "black--text font-weight-bold secondary capitalize",
  },
  {
    text: "Submitted At",
    value: "submitted_at",
    class: "black--text font-weight-bold secondary capitalize",
  },
  {
    text: "Verified At",
    value: "verified_at",
    class: "black--text font-weight-bold secondary capitalize",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const miscellaneousFeeHeaders = [
  {
    text: "Particular",
    value: "particular",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Fee",
    value: "fee",
    class: "black--text font-weight-bold secondary",
    width: "15%",
  },
  {
    text: "Search Fee(in ₹)",
    value: "search_fee",
    class: "black--text font-weight-bold secondary",
  },

  {
    text: "Postal Fee(in ₹)",
    value: "postal_fee",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Document Visible to",
    value: "student_status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const studentActiveStatusHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Employee ID",
    value: "employee_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Current Term",
    value: "current_term_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "current_status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Actions",
    value: "actions",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const studentRequestHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "student_info.name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "student_info.email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "student_info.mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Documents Needed",
    value: "particulars",
    class: "black--text font-weight-bold secondary",
    width: "20%",
  },
  {
    text: "Postal Required",
    value: "is_postal_required",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Submitted At",
    value: "inserted_at",
    class: "black--text font-weight-bold secondary",
    width: "15%",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const studentDetailHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Employee ID",
    value: "employee_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "year",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Current Term",
    value: "current_term_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "current_status",
    class: "black--text font-weight-bold secondary",
  },
];

export const exitStudentHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Employee ID",
    value: "employee_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Current Term",
    value: "current_term_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Date Of Exit",
    value: "date_of_exit",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Date Of Exit Raised",
    value: "exit_raised",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Remarks",
    value: "actions",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const CFOBulkPaymentHeaders = [
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction ID",
    value: "transaction_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction Date",
    value: "transaction_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Total No. of Students",
    value: "no_of_students",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (₹)",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "View",
    value: "view",
    class: "black--text font-weight-bold secondary",
  },
];

export const requestFeeHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "student_info.name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile No",
    value: "student_info.mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "student_info.email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Current Term",
    value: "term_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Particular",
    value: "particular",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (in ₹)",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Receipt Number",
    value: "receipt_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Reference Number",
    value: "transaction_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction Date",
    value: "transaction_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const excessPaymentHeaders = [
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile No",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Particular",
    value: "fee_type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction ID",
    value: "transaction_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction Date",
    value: "transaction_date",
    class: "black--text font-weight-bold secondary",
  },
];

export const exportHeaders = [
  {
    text: "Reference",
    value: "reference",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Type",
    value: "type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Created At",
    value: "created_at",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const studentExamResultHeaders = [
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Programme",
    value: "programme",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Semester",
    value: "semester",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Student Name",
    value: "student_name",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Code",
    value: "course_code",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Name",
    value: "course_desc",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Semester",
    value: "subject_semester",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Type",
    value: "course_type",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Elective Status",
    value: "elective_status",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Credit",
    value: "credit",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Internal Mark",
    value: "internal_mark",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Max Internal",
    value: "max_internal",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "ESM",
    value: "total_mark",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Grade",
    value: "grade",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "SGPA",
    value: "sgpa",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "CGPA",
    value: "cgpa",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Provisional Certificate SL No",
    value: "provisional_certificate_sl_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Degree Certificate SL No",
    value: "degree_certificate_sl_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Cummulative SL No",
    value: "cummulative_sl_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Grade Sheet SL No",
    value: "grade_sheet_sl_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const studentAnnualExamResultHeaders = [
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Programme",
    value: "programme",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Year",
    value: "year",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Student Name",
    value: "student_name",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Code",
    value: "course_code",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Name",
    value: "course_desc",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Year",
    value: "subject_year",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Credit",
    value: "credit",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Internal Mark",
    value: "internal_mark",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Max Internal",
    value: "max_internal",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "External",
    value: "external",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Max External",
    value: "max_external",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Total Marks",
    value: "total_mark",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Result",
    value: "result",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Provisional Certificate SL No",
    value: "provisional_certificate_sl_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Degree Certificate SL No",
    value: "degree_certificate_sl_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Cummulative SL No",
    value: "cummulative_sl_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Grade Sheet SL No",
    value: "grade_sheet_sl_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const unsettledTransactionHeaders = [
  {
    text: "Application ID",
    value: "application_id",
    align: "center",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Particular",
    value: "fee_type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction ID",
    value: "transaction_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction Date",
    value: "transaction_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (in ₹)",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
];

export const studentInvoiceConcessionHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile No",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Current Term",
    value: "term_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Type",
    value: "type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const termSessionHeaders = [
  {
    text: "Term Session",
    value: "id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch Code",
    value: "admission_batch_code",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Term Type",
    value: "term_type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Start",
    value: "start",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "End",
    value: "end",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  // {
  //   text: "Active Status",
  //   value: "active",
  //   class: "black--text font-weight-bold secondary",
  // },
];

export const studentPaymentSessionHeaders = [
  {
    text: "Term Session",
    value: "term_session_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch Code",
    value: "batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Academic Year",
    value: "year",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Term Type",
    value: "term_type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Term No",
    value: "term_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Plan Selected",
    value: "plan_selected",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (₹)",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Paid",
    value: "paid",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Paid On",
    value: "paid_on",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Invoice ID",
    value: "invoice_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Plan ID",
    value: "plan_id",
    class: "black--text font-weight-bold secondary",
  },
];

export const studentOldPaymentInvoiceHeaders = [
  {
    text: "Term Session",
    value: "term_session_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile No",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Term",
    value: "term_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (₹)",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Raised Batch",
    value: "fee_raised_batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Particular",
    value: "type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Receipt Number",
    value: "receipt_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Reference Number",
    value: "transaction_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction Date",
    value: "transaction_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "status",
    class: "black--text font-weight-bold secondary",
  },
];

export const auditReportHeaders = [
  {
    text: "S.No.",
    value: "index",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Payment Term",
    value: "term_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Receipt Number",
    value: "receipt_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Receipt Date",
    value: "transaction_date",
    class: "black--text font-weight-bold secondary",
  },
];

export const auditSummaryHeaders = [
  {
    text: "Programme",
    value: "term_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Count",
    value: "count",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
];

export const studentProgressionHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Student Name",
    value: "student_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "year_batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Term",
    value: "current_term_no",
    class: "black--text font-weight-bold secondary",
  },
];

export const studentDiscountHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "DOB",
    value: "dob",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Category",
    value: "category",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Discount utilized",
    value: "is_discount_applied",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const studentInternalMarkHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Batch",
    value: "year_batch",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Code",
    value: "course_code",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Name",
    value: "course_desc",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Semester",
    value: "term_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Credits",
    value: "credits",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Handled By",
    value: "course_handled_by",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Mark",
    value: "mark",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  // {
  //   text: "Actions",
  //   value: "action",
  //   class: "black--text font-weight-bold secondary",
  //   sortable: false,
  // },
];

export const studentExternalMarkHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Batch",
    value: "year_batch",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Code",
    value: "course_code",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Name",
    value: "course_desc",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Semester",
    value: "current_term_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Credits",
    value: "credits",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Handled By",
    value: "course_handled_by",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Exam Year",
    value: "exam_year",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Exam Month",
    value: "exam_month",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "External Mark",
    value: "mark",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Actions",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const examResultHeaders = [
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Semester",
    value: "current_term_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Student Name",
    value: "student_name",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Code",
    value: "course_code",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Name",
    value: "course_desc",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Semester",
    value: "term_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Type",
    value: "course_type",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Elective Status",
    value: "elective_status",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Credit",
    value: "credits",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Internal Mark",
    value: "internal_mark",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Max Internal",
    value: "max_internal",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "ESM",
    value: "total",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Grade",
    value: "grade",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "SGPA",
    value: "sgpa",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "CGPA",
    value: "cgpa",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Provisional Certificate SL No",
    value: "provisional_certificate_sl_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Degree Certificate SL No",
    value: "degree_certificate_sl_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Cummulative SL No",
    value: "cummulative_sl_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Grade Sheet SL No",
    value: "grade_sheet_sl_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const studentTransferHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "application_status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "year_batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "",
    value: "select",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];
export const consolidatedFeeReportHeaders = [
  {
    text: "S.No.",
    value: "index",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Payment Term",
    value: "term_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Particular",
    value: "type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Receipt Number",
    value: "receipt_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Receipt Date",
    value: "transaction_date",
    class: "black--text font-weight-bold secondary",
  },
];

export const programAddonHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Description",
    value: "description",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Type",
    value: "type",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Active Status",
    value: "active",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Fee Schedule",
    value: "fee_schedule",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Actions",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const feeScheduleHeaders = [
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Enrollment End",
    value: "enrollment_end",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Actions",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const partnerProgramAddonsHeaders = [
  {
    text: "Name",
    value: "student_info.name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "student_info.email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "USN ID",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme Add-ons",
    value: "program_addons",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Add-on referral partner",
    value: "convinced_by_partner",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const addonProgrammeFeeHeaders = [
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "student_details.name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile No",
    value: "student_details.mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "student_details.email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Current Term",
    value: "student_details.current_term_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Amount (₹)",
    value: "amount",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "student_details.program_id",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Partner",
    value: "student_details.partner_id",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Receipt Number",
    value: "receipt_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Reference Number",
    value: "transaction_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Transaction Date",
    value: "transaction_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "HSN/SAC",
    value: "sac",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Add-on Details",
    value: "addon_split_action",
    sortable: false,
    class: "black--text font-weight-bold secondary",
  },
];

export const electiveConfigurationHeaders = [
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme Scheme",
    value: "program_scheme_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Term No",
    value: "term_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Students",
    value: "total_students",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Start Date",
    value: "from_date",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "End Date",
    value: "to_date",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Student Electives",
    value: "student_electives",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Actions",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const studentElectiveHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Electives",
    value: "electives",
    class: "black--text font-weight-bold secondary",
  },
  // {
  //   text: "Actions",
  //   value: "action",
  //   class: "black--text font-weight-bold secondary",
  //   sortable: false,
  // },
];

export const studentAttendanceHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Present",
    value: "present_count",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Absent",
    value: "absent_count",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Not uploaded",
    value: "not_uploaded_count",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Attendance %",
    value: "attendance_percentage",
    class: "black--text font-weight-bold secondary",
  },
];

export const webinarSessionHeaders = [
  {
    text: "Programme",
    value: "program_code",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Semester",
    value: "semester_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Class ID",
    value: "class_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Course",
    value: "course_code",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Faculty",
    value: "faculty_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Date",
    value: "webinar_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Time",
    value: "time",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Slot",
    value: "slot",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "From Time",
    value: "from_time",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "To Time",
    value: "to_time",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Rescheduled",
    value: "rescheduled",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Students",
    value: "total_students",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Uploaded",
    value: "uploaded_count",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Present",
    value: "present_count",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Absent",
    value: "absent_count",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Not uploaded",
    value: "not_uploaded_count",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Attendance %",
    value: "attendance_percentage",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
    align: "right",
  },
];

export const matrixHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "status",
    class: "black--text font-weight-bold secondary",
    align: "center",
  },
];

export const referralHeaders = [
  {
    text: "Referrer USN",
    value: "referrer_usn_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Referrer Name",
    value: "referrer_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Referrer Email",
    value: "referrer_email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Referrer Batch",
    value: "referrer_batch",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "referrer_partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Candidate",
    value: "full_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programmes Interested",
    value: "program_names",
    sortable: false,
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "City/Town",
    value: "city",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "State",
    value: "state",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Referred On",
    value: "referred_on",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "status",
    align: "center",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Actions",
    value: "actions",
    align: "center",
    sortable: false,
    class: "black--text font-weight-bold secondary",
  },
];

export const referralVisibilityHeaders = [
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Batch",
    value: "program_batch_name",
    align: "center",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Visibility",
    value: "active",
    align: "center",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Actions",
    value: "actions",
    align: "center",
    sortable: false,
    class: "black--text font-weight-bold secondary",
  },
];

export const loanPaymentHeaders = [
  {
    text: "Application ID",
    value: "application_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Programme",
    value: "program_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Loan Case Number",
    value: "loan_case_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Status",
    value: "status",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "UTR",
    value: "utr_number",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "UTR Date",
    value: "utr_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Disbursed Amount",
    value: "disbursed_amount",
    align: "end",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Balance",
    value: "plan_amount_balance",
    align: "end",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Last Synced",
    value: "last_synced_at",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Action",
    value: "action",
    align: "center",
    sortable: false,
    class: "black--text font-weight-bold secondary",
  },
];

export const examPaperHeaders = [
  {
    text: "USN",
    value: "usn_id",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Programme",
    value: "program_name",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Scheme",
    value: "program_scheme_name",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Term",
    value: "term_no",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Type",
    value: "type",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Status",
    value: "subject_status",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Code",
    value: "course_code",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Course Name",
    value: "course_name",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Credits",
    value: "credits",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Handled By",
    value: "handled_by",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Amount (₹)",
    value: "amount",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Invoiced",
    value: "invoiced",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Fee Raised Batch",
    value: "exam_batch",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Exam Batch",
    value: "exam_sitting",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "",
    value: "actions",
    width: 60,
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const userHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Email",
    value: "email",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Mobile Number",
    value: "mobile_no",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Role",
    value: "role",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Partner",
    value: "partner_id",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Active Status",
    value: "active",
    class: "black--text font-weight-bold secondary capitalize",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const roleHeaders = [
  {
    text: "Name",
    value: "name",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Code",
    value: "code",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Menu Items",
    value: "menu_items",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Active Status",
    value: "active",
    class: "black--text font-weight-bold secondary capitalize",
  },
  {
    text: "Action",
    value: "action",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const webinarRunHeaders = [
  {
    text: "Start Date",
    value: "start_date",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Title",
    value: "title",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Max Session per Slot",
    value: "max_per_slot",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Scheduled On",
    value: "inserted_at",
    class: "black--text font-weight-bold secondary",
  },
  {
    text: "Schedules",
    value: "schedules",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
  {
    text: "Actions",
    value: "actions",
    class: "black--text font-weight-bold secondary",
    sortable: false,
  },
];

export const refundStudentHeaders = [
  { text: "Name", value: "name", class: headerClass },
  { text: "USN", value: "usn_id", class: headerClass },
  { text: "Application ID", value: "application_id", class: headerClass },
  {
    text: "Mobile",
    value: "mobile_no",
    class: headerClass,
    sortable: false,
  },
  {
    text: "Payments",
    value: "tally.payments_count",
    class: headerClass,
    align: "center",
  },
  { text: "Amount Paid (₹)", value: "tally.paid", class: headerClass },
  { text: "Refunded (₹)", value: "tally.refunded", class: headerClass },
  { text: "Total Amount (₹)", value: "tally.net", class: headerClass },
  { text: "", value: "actions", class: headerClass, sortable: false },
];

export const refundPaymentHeaders = [
  { text: "Date", value: "transaction_date", class: headerClass },
  { text: "Fee Type", value: "fee_type", class: headerClass },
  {
    text: "Payment Term",
    value: "term_no",
    class: headerClass,
    align: "center",
  },
  { text: "Amount (₹)", value: "amount", class: headerClass },
  { text: "Receipt No", value: "receipt_number", class: headerClass },
  { text: "Transaction ID", value: "transaction_id", class: headerClass },
  {
    text: "Refund",
    value: "refund_status",
    class: headerClass,
    sortable: false,
  },
  { text: "", value: "actions", class: headerClass, sortable: false },
];

export const refundedListHeaders = [
  { text: "Refund Date", value: "refunded_date", class: headerClass },
  { text: "Name", value: "student_name", class: headerClass },
  { text: "USN", value: "usn_id", class: headerClass },
  { text: "Application ID", value: "application_id", class: headerClass },
  { text: "Fee Type", value: "fee_type", class: headerClass },
  {
    text: "Payment Term",
    value: "term_no",
    class: headerClass,
    align: "center",
  },
  { text: "Paid (₹)", value: "paid_amount", class: headerClass },
  { text: "Refunded (₹)", value: "amount", class: headerClass },
  {
    text: "Refund Transaction ID",
    value: "refund_transaction_id",
    class: headerClass,
  },
  { text: "Status", value: "status", class: headerClass },
  { text: "", value: "actions", class: headerClass, sortable: false },
];
